import { TemplateKeys } from '../../types/types';
import { MsgTemplate, TemplateButtons } from '../../schema/message/inferface';
import {
  messageTemplateSchema,
  TemplateCard,
  templateSchemaV2,
  templateSchemaV3,
  transformSchemaV2toV1,
  transformSchemaV3toV1,
} from '../../schema/message/template-schema';
import { TemplateButtonTypeEnum } from '../../schema/message/enum';
import { replacePlaceholders } from '../replace-placeholders';

export const getValidTemplate = (
  template: MsgTemplate,
  templateName?: TemplateKeys
): MsgTemplate => {
  let result: MsgTemplate = template;
  if (messageTemplateSchema.safeParse(template).success) {
    result = template;
  } else if (templateSchemaV2.safeParse(template).success) {
    result = transformSchemaV2toV1.parse(template) as MsgTemplate;
  } else if (templateSchemaV3.safeParse(template).success) {
    result = transformSchemaV3toV1.parse(template) as MsgTemplate;
  }
  if (templateName) {
    result = Object.fromEntries(
      Object.entries(result).map(([k, v]) => [templateName ?? k, v])
    );
  }
  return result;
};

export const getButtonsFromTemplate = (
  msgTemplate: MsgTemplate
): TemplateButtons[] => {
  const template = Object.values(msgTemplate)?.[0] || {};
  const { components = [], params = [] } = template || {};
  const btnComponents =
    components.find((x) => x.type.toLowerCase() === 'buttons')?.buttons || [];
  const btnParams = params.filter((x) => x.type.toLowerCase() === 'button');
  const buttons: TemplateButtons[] = btnComponents.map(
    ({ text, url }, index) => {
      const btnParameters = btnParams?.[index];
      const btnType =
        btnParameters?.sub_type?.toLowerCase() === 'url'
          ? TemplateButtonTypeEnum.URL
          : TemplateButtonTypeEnum.QUICK_REPLY;
      const navigateTo = url
        ? replacePlaceholders(url, [
            btnParameters?.parameters?.[0]?.text ||
              btnParameters?.parameters?.[0]?.payload ||
              '',
          ])
        : undefined;
      return {
        text: text,
        type: btnType,
        condition: true,
        permissions: [],
        onPress: () => {},
        disabled: btnType === TemplateButtonTypeEnum.QUICK_REPLY,
        navigateTo,
      } as TemplateButtons;
    }
  );
  return buttons;
};

export const getCarouselCardButtons = (
  card: TemplateCard
): TemplateButtons[] => {
  const { buttons = [] } = card;

  return buttons.map(({ parameters, text, type, url }) => {
    const btnType =
      type.toLowerCase() === 'url'
        ? TemplateButtonTypeEnum.URL
        : TemplateButtonTypeEnum.QUICK_REPLY;
    const navigateTo = url
      ? replacePlaceholders(url, [
          parameters?.[0]?.text || parameters?.[0]?.payload || '',
        ])
      : undefined;
    return {
      text: text,
      type: btnType,
      condition: true,
      permissions: [],
      onPress: () => {},
      disabled: btnType === TemplateButtonTypeEnum.QUICK_REPLY,
      navigateTo,
    } as TemplateButtons;
  });
};
